import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { AsyncButton, QuestionInputs, SaveStates } from '@infl-ts/ui-advocate-components';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import * as E from 'fp-ts/Either';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";

var NetPromoterScoreStage = function NetPromoterScoreStage(_ref) {
  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      prospect = _ref.prospect;
  var npsForm = useForm({
    defaultValues: _defineProperty({}, stage.question.id, '0')
  });
  useEffect(function () {
    npsForm.reset(_defineProperty({}, stage.question.id, '0'));
  }, [stage.id]);
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsx(StageLayout, {
    showPublicResponseMessage: true,
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(AsyncButton, {
      text: ['Submitting...', 'Saved', stage.completionText || 'Next', stage.completionText || 'Next'],
      status: mutationValue,
      onClick: npsForm.handleSubmit(function (data) {
        return completeStage({
          npsInput: {
            stageID: stage.id,
            activityID: activity === null || activity === void 0 ? void 0 : activity.id,
            response: {
              id: stage.question.id,
              ratingResponse: Number.parseInt(data[stage.question.id])
            }
          }
        });
      })
    }),
    "data-element": "StageLayout",
    "data-component": "NetPromoterScoreStage",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(QuestionInputs, {
      questions: [stage.question],
      questionForm: npsForm,
      "data-element": "QuestionInputs",
      "data-component": "NetPromoterScoreStage",
      "data-source-file": "index.tsx"
    })
  });
};

export default NetPromoterScoreStage;